import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconTimeBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="nonzero">
				<path
					fill="#E42822"
					d="M13.072 14.548a.369.369 0 0 1 .385.63l-.023.013-5.732 3.226a.369.369 0 0 1-.384-.63l.022-.013z"
				/>
				<path
					fill="#E42822"
					d="M16.157 8.957a.369.369 0 0 1 .655.339l-.012.023-3.225 5.731a.369.369 0 0 1-.655-.338l.012-.023z"
				/>
				<path
					fill="#E42822"
					d="M16.298 8.817a.369.369 0 0 1 .384.629l-.023.013-5.731 3.226a.369.369 0 0 1-.385-.629l.023-.014z"
				/>
				<path
					fill="#E42822"
					d="M10.425 12.183a.369.369 0 0 1 .655.338l-.012.023-3.226 5.732a.369.369 0 0 1-.654-.338l.012-.024z"
				/>
				<path
					fill="#E42822"
					d="M10.486 12.103a.37.37 0 0 1 .501-.019l.02.019 2.507 2.506a.369.369 0 0 1-.502.54l-.02-.019-2.506-2.505a.37.37 0 0 1 0-.522"
				/>
				<g fill="#000">
					<path d="M12 5.297a8.32 8.32 0 1 0 0 16.64 8.32 8.32 0 0 0 0-16.64m0 .737A7.583 7.583 0 1 1 12 21.2a7.583 7.583 0 0 1 0-15.165M10.793 1.84a.369.369 0 0 1 .025.737h-.025a.707.707 0 0 0-.035 1.414l.035.001a.369.369 0 1 1 0 .738 1.445 1.445 0 1 1 0-2.89M13.207 1.84a1.445 1.445 0 1 1 0 2.89.369.369 0 0 1-.025-.737h.025a.707.707 0 0 0 .034-1.415h-.034a.369.369 0 1 1 0-.738" />
				</g>
				<path
					fill="#000"
					d="M12.131 3.031c.265 0 .481.152.499.344l.001.025v2.265c0 .204-.224.37-.5.37-.265 0-.481-.153-.499-.344V3.4c0-.204.223-.369.5-.369"
				/>
				<g fill="#000">
					<path d="M19.893 13.248c.204 0 .369.224.369.5 0 .265-.152.481-.344.499l-.025.001h-1.35c-.203 0-.368-.224-.368-.5 0-.265.151-.481.343-.499l.025-.001zM5.415 13.248c.204 0 .369.224.369.5 0 .265-.152.481-.344.499l-.025.001h-1.35c-.203 0-.368-.224-.368-.5 0-.265.151-.481.343-.499l.025-.001zM12.087 19.785c.265 0 .482.152.5.344v1.375c0 .203-.223.368-.5.368-.264 0-.48-.151-.498-.343l-.002-.025v-1.35c0-.204.224-.369.5-.369" />
				</g>
				<path
					fill="#000"
					d="M12.087 5.357c.265 0 .482.152.5.344v1.375c0 .203-.223.369-.5.369-.264 0-.48-.152-.498-.344l-.002-.025v-1.35c0-.204.224-.369.5-.369M13.207 1.84c.204 0 .369.224.369.5 0 .265-.152.481-.344.499l-.025.001h-2.414c-.204 0-.37-.224-.37-.5 0-.265.153-.481.344-.499l.026-.001zM13.207 3.992c.204 0 .369.224.369.5 0 .265-.152.481-.344.499l-.025.001h-2.414c-.204 0-.37-.224-.37-.5 0-.264.153-.481.344-.499h2.44"
				/>
			</g>
		</svg>
	);
}
